import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import {Box} from '@mui/material';
import DataSendButton from '../dataload/DataSendButton';
import ErrorLogButton from '../errorlog/ErrorLogButton';
import WarningButton from '../warning/warning/WarningButton';
import NotificationsButton from '../notification/NotificationsButton';
import ExecuteScriptButton from './ExecuteScriptButton';
import ExecuteCommandButton from './ExecuteCommandButton';
import PlayerReportButton from "../playerreport/PlayerReportButton";
import SearchBar from "../search/SearchBar";
import PlayerCounter from "./PlayerCounter";
import TpsCounter from "./TpsCounter";
import UserProfileButton from "./UserProfileButton";
import DashboardHelpButton from "./DashboardHelpButton";
import DashboardHomeButton from "./DashboardHomeButton";
import NavbarToggleButton from "./NavbarToggleButton";
import FeedbackButton from "../feedback/FeedbackButton";

export default function Header({toggleNavbar}) {

    return (
        <AppBar position='relative' elevation={0}>
            <Toolbar variant='dense'
                     sx={{
                         "@media (min-width: 0px)": {paddingRight: 0, paddingLeft: 0}
                     }}>
                <NavbarToggleButton toggleNavbar={toggleNavbar}/>
                <DashboardHomeButton/>
                <Box sx={{flexGrow: 1}}/>
                <SearchBar/>
                <Box sx={{flexGrow: 1}}/>
                <TpsCounter/>
                <PlayerCounter/>
                <NotificationsButton/>
                <WarningButton/>
                <PlayerReportButton/>
                <FeedbackButton/>
                <ErrorLogButton/>
                <ExecuteCommandButton/>
                <ExecuteScriptButton/>
                <DataSendButton/>
                <DashboardHelpButton/>
                <UserProfileButton/>
            </Toolbar>
        </AppBar>
    )
}